// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__HNFpe","outline":"button_outline__r0txN","primary":"button_primary__QJCxB","inverse":"button_inverse__pLg_7","buttonGrid":"button_buttonGrid___GDKt"};